<div id="popup">
    <div class="title-head index-head" fxLayout="row" fxLayoutAlign="space-between center">
        <span>
            Confirm
        </span>
        <button [attr.guide]="'template-confirm-popup-btn-1' + '__' + sanitizedUrl" mat-icon-button>
            <mat-icon (click)="close()">
                close
            </mat-icon>
        </button>
    </div>
    <mat-dialog-content [ngStyle.lt-md]="'max-height: 100%'" style=" MARGIN: 0PX; padding: 0px;">
        <div class="padding-11">
            <div fxLayout="column">

                <div class="padding-index">
                    <span> The template will replace the subject and content of this email.</span>
                </div>

                <div class="padding-index">
                    <span> Are you sure you want to continue?</span>
                </div>

            </div>

            <div class="padding-top10" fxLayoutAlign="end center" fxLayoutGap="10px">

                <button [attr.guide]="'template-confirm-popup-btn-2' + '__' + sanitizedUrl" type="button" mat-raised-button (click)="close()">Cancel
                </button>

                <button [attr.guide]="'template-confirm-popup-btn-3' + '__' + sanitizedUrl" mat-raised-button color="primary" (click)="submit()">OK</button>


            </div>
        </div>
    </mat-dialog-content>
</div>